<script setup lang="ts">
import SearchClaimTable from '../search/SearchClaimTable.vue';
import Overview from '@/pages/plugin/Overview.vue';

import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { ShieldExclamationIcon } from '@heroicons/vue/24/outline'

import { useClaimStore, useContextStore, useNotificationStore } from '@/store';
import { ref, watch } from 'vue';
import Front from '@frontapp/plugin-sdk';

function handleClaimClick(claimId: string) {
  selectedClaimId.value = claimId;
}

const selectedClaimId = ref<string | null>(null);

const mergeModal = ref({
  open: false,
  attachOnly: true,
});

async function linkConversationToSelectedClaim() {
  const claimId = selectedClaimId.value;
  const currentConversationId = useContextStore().frontContext?.conversation?.id;
  const {frontContext} = useContextStore();

  if (!(claimId && currentConversationId && frontContext)) {
    useNotificationStore().emitNotification({
      title: "Impossible d'effectuer l'opération",
      type: "warning"
    });
  }

  await frontContext.addLink(`https://admin.upclaim.eu/claims/${claimId}`, "Admin")

  useNotificationStore().emitNotification({
    title: "Opération effectuée avec succès",
  }); 
}

watch(selectedClaimId, async (newClaimId) => {
  if (newClaimId) {
    useClaimStore().retrieveClaim(newClaimId);
  }
})
</script>
<template>
  <!-- No claim is linked to the current Front conversation -->
  <!-- <Suspense>
  <SearchClaimToLink />
  <template #fallback>loading..</template>
</Suspense> -->
  <TransitionRoot as="template" :show="true">
    <Dialog as="div" class="fixed inset-0 z-10 overflow-y-auto">
      <div class="items-end justify-center block min-h-screen px-4 py-40 text-center sm:py-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
          leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div
            class="relative inline-block px-4 pt-5 pb-4 overflow-hidden text-left align-bottom transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div>
              <div class="flex items-center justify-center w-12 h-12 mx-auto rounded-full bg-amber-100">
                <ShieldExclamationIcon class="w-6 h-6 text-amber-600" aria-hidden="true" />
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" class="text-lg font-medium leading-6 text-gray-900">Pas de claim associée
                </DialogTitle>
                <div class="mt-2">
                  <p class="text-base text-gray-500">
                    Cette conversation n'a pas de claim associée. <br>
                    Vous pouvez ignorer ce message ou <b>associer cette conversation à une claim</b>
                  </p>
                </div>
              </div>
            </div>

            <SearchClaimTable @claimClick="handleClaimClick" :selectedClaimId="selectedClaimId" :hitsPerPage="3" />

            <div v-if="selectedClaimId" class="-mt-10">
              <div class="relative my-4">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                  <div class="w-full border-t border-gray-300"></div>
                </div>
                <div class="relative flex justify-center">
                  <span class="px-2 text-sm text-gray-500 bg-white">Claim selectionnée :</span>
                </div>
              </div>
              <Overview />
              <div class="py-5 sm:py-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button @click="() => selectedClaimId = null" type="button"
                class="inline-flex justify-center w-full px-4 py-2 mt-3 text-base font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm cursor-pointer hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 sm:col-start-1 sm:text-sm">
                Annuler
              </button>
              <button type="button" @click="linkConversationToSelectedClaim"
                class="inline-flex justify-center w-full px-4 py-2 text-sm font-medium text-white bg-blue-800 border border-transparent rounded-md shadow-sm cursor-pointer hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600">
                Associer
              </button>
            </div>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>